"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardSection = void 0;
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var types_1 = require("@pbl/pbl-react-core/lib/models/reward/types");
var hideable_1 = require("@pbl/pbl-react-web-components/lib/hideable");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var constants_1 = __importStar(require("../../../config/constants"));
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_slick_1 = __importDefault(require("react-slick"));
var react_redux_1 = require("react-redux");
var colors_1 = __importDefault(require("../../../assets/jss/colors"));
var useRewardListData_1 = require("../../../shared/hooks/providers/rewards/useRewardListData");
var FeaturedRewardsCard_1 = __importDefault(require("./FeaturedRewardsCard"));
var RewardCard_1 = __importDefault(require("./RewardCard"));
var rewardUtil_1 = require("./rewardUtil");
var styles = function (theme) {
    return (0, core_1.createStyles)({
        divider: {
            backgroundColor: colors_1.default.textSecondaryColor.hex()
        }
    });
};
var RewardSection = function (_a) {
    var type = _a.type, onRewardSelect = _a.onRewardSelect;
    var t = (0, react_i18next_1.useTranslation)().t;
    var loading = (0, react_redux_1.useSelector)(function (state) { return state.reward; }).loading;
    var _b = (0, useRewardListData_1.useRewardListData)(type), rewards = _b.rewards, featuredRewards = _b.featuredRewards, couponDetails = _b.couponDetails, featuredDetails = _b.featuredDetails;
    var theme = (0, core_1.useTheme)();
    var useStyles = (0, core_1.makeStyles)(styles);
    var classes = useStyles(theme);
    var PrevArrow = function (props) {
        var onClick = props.onClick;
        return (React.createElement(core_1.IconButton, { onClick: onClick, "aria-label": "Previous Slider" },
            React.createElement(icons_1.ArrowBackIosRounded, { color: 'primary', fontSize: 'small' })));
    };
    var NextArrow = function (props) {
        var onClick = props.onClick;
        return (React.createElement(core_1.IconButton, { onClick: onClick, "aria-label": "Next Slider" },
            React.createElement(icons_1.ArrowForwardIosRounded, { color: 'primary', fontSize: 'small' })));
    };
    var settings = {
        accessibility: true,
        dots: true,
        infinite: true,
        speed: 500,
        autoplaySpeed: 8000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: React.createElement(PrevArrow, null),
        nextArrow: React.createElement(NextArrow, null)
    };
    var getBanner = function (r, idx, featured) {
        var _a, _b;
        var showEndedBanner = (0, rewardUtil_1.isEnded)(r.end);
        var showEndingSoonBanner = r.type === types_1.RewardType.DRAW && (0, rewardUtil_1.isEndingSoon)(r.endingSoon, r.entryEnd);
        var showSoldOutBanner = featured
            ? featuredDetails[idx] && ((_a = featuredDetails[idx]) === null || _a === void 0 ? void 0 : _a.remaining) === 0
            : couponDetails[idx] && ((_b = couponDetails[idx]) === null || _b === void 0 ? void 0 : _b.remaining) === 0;
        return showEndedBanner
            ? { showBanner: true, bannerText: t("reward.rewardStatus.ended"), styleType: 'GrayedOut' }
            : showEndingSoonBanner
                ? {
                    showBanner: true,
                    bannerText: t("reward.rewardStatus.endingSoon"),
                    styleType: 'WhiteHighlight'
                }
                : showSoldOutBanner
                    ? { showBanner: true, bannerText: t('reward.soldOut'), styleType: 'GrayedOut' }
                    : {};
    };
    var rewardList = React.useMemo(function () {
        return rewards === null || rewards === void 0 ? void 0 : rewards.map(function (r, idx) {
            var _a;
            var banner = getBanner(r, idx, false);
            var textDescription = ((_a = r.summary) === null || _a === void 0 ? void 0 : _a.trim()) || constants_1.NBSP;
            return (React.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 4, key: "reward_card_".concat(idx) },
                React.createElement(RewardCard_1.default, { reward: r, banner: banner, categoryName: type, preview: textDescription, onPress: function () { return onRewardSelect(r); } })));
        });
    }, [rewards, type, couponDetails, t]);
    if (loading) {
        return React.createElement(package_1.AppSpinner, { label: 'Loading...' });
    }
    else if (!featuredRewards.length && rewards.length < 0) {
        return React.createElement(package_1.NoResultsFound, { title: t('rewards.noResults') });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(hideable_1.Hideable, { show: Boolean(featuredRewards === null || featuredRewards === void 0 ? void 0 : featuredRewards.length) }, (featuredRewards === null || featuredRewards === void 0 ? void 0 : featuredRewards.length) === 1 ? (React.createElement(FeaturedRewardsCard_1.default, { reward: featuredRewards[0], idx: 0, getBanner: getBanner, onRewardSelect: onRewardSelect })) : (React.createElement(react_slick_1.default, __assign({}, settings), featuredRewards === null || featuredRewards === void 0 ? void 0 : featuredRewards.map(function (fr, idx) { return (React.createElement(FeaturedRewardsCard_1.default, { reward: fr, idx: idx, getBanner: getBanner, onRewardSelect: onRewardSelect })); })))),
        React.createElement(hideable_1.Hideable, { show: Boolean(rewards === null || rewards === void 0 ? void 0 : rewards.length) },
            React.createElement(core_1.Hidden, { smDown: true },
                constants_1.default.SHOW_REWARD_CATEGORY_NAME ? (React.createElement(React.Fragment, null,
                    React.createElement(core_1.Typography, { component: "h2", variant: "h6", gutterBottom: true, color: "textPrimary", style: { marginTop: '40px' } }, type === types_1.RewardType.DRAW
                        ? 'Drawings'
                        : type === types_1.RewardType.COUPON
                            ? 'Coupons'
                            : ''),
                    React.createElement(core_1.Divider, { variant: "fullWidth", "aria-hidden": "true", style: { height: '1px' }, className: classes.divider }))) : null,
                React.createElement(core_1.Grid, { container: true, spacing: 4, style: { marginTop: 40 } }, rewardList)),
            React.createElement(core_1.Hidden, { mdUp: true },
                constants_1.default.SHOW_REWARD_CATEGORY_NAME ? (React.createElement(React.Fragment, null,
                    React.createElement(core_1.Typography, { component: "h2", variant: "h6", gutterBottom: true, color: "textSecondary", style: { marginTop: '20px' } }, type === types_1.RewardType.DRAW
                        ? 'Drawings'
                        : type === types_1.RewardType.COUPON
                            ? 'Coupons'
                            : ''),
                    React.createElement(core_1.Divider, { variant: "fullWidth", "aria-hidden": "true", style: { height: '1px', marginBottom: '20px' }, className: classes.divider }))) : null,
                React.createElement(core_1.Grid, { container: true, spacing: 4 }, rewardList)))));
};
exports.RewardSection = RewardSection;
//# sourceMappingURL=RewardSection.js.map